<template>
  <div class="progress-bar" :class="`theme-${theme}`">
    <div class="progress-bar-bg" :style="`height: ${height}px;`">
      <div class="progress-bar-fill" :style="`width: ${percentage}%; height: ${height}px;`"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',

  props: {
    min: {
      type: Number,
      default: 0,
      required: false
    },
    max: {
      type: Number,
      default: 100,
      required: false
    },
    progress: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 8
    },
    theme: {
      type: String,
      default: 'pink'
    }
  },

  computed: {
    percentage () {
      return ((this.progress - this.min) / (this.max - this.min)) * 100
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';

.progress-bar {
  margin-top: 6px;
  margin-bottom: 6px;

  .progress-bar-bg {
    width: 100%;
  }

  &.theme-pink {

    .progress-bar-bg {
      background-color: $color-gray-light;
    }

    .progress-bar-fill {
      background-color: $color-brand-main;
    }
  }

  &.theme-white {

    .progress-bar-bg {
      background-color: rgba($color-white, 0.4);
    }

    .progress-bar-fill {
      background-color: rgba($color-white, 0.7);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue